import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import API_BASE_URL from "../config";

export default function ForgotPassword() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    try {
      setSubmitting(true);

      const res = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ email })
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || "Unable to process request");
      }

      setSuccessMsg(
        "If an account exists for that email, a password reset link has been sent."
      );
    } catch (err) {
      setErrorMsg(err.message || "Unable to process request.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-shell">
      <div className="auth-background-orb auth-background-orb-one" />
      <div className="auth-background-orb auth-background-orb-two" />

      <div className="auth-card auth-card-login">
        <div className="auth-brand">
          <div className="auth-brand-logo" aria-label="Agent Book CRM logo">
            <span>AB</span>
          </div>

          <div className="auth-brand-copy">
            <p className="auth-brand-kicker">Account Recovery</p>
            <h1 className="auth-brand-title">Forgot Password</h1>
            <p className="auth-brand-subtitle">
              Enter your email address and we will send you a secure link to reset your password.
            </p>
          </div>
        </div>

        <form className="auth-form" onSubmit={handleSubmit}>
          <div className="auth-form-section">
            <div className="auth-field">
              <label>Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                autoComplete="email"
                required
              />
            </div>
          </div>

          {errorMsg && <div className="auth-error-banner">{errorMsg}</div>}
          {successMsg && <div className="auth-success-banner">{successMsg}</div>}

          <button
            type="submit"
            className="auth-primary-btn"
            disabled={submitting}
          >
            {submitting ? "Sending..." : "Send Reset Link"}
          </button>

          <div className="auth-secondary-actions">
            <button
              type="button"
              className="auth-ghost-btn"
              onClick={() => navigate("/login")}
            >
              Back to Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}